import { Modal } from "antd";
import styled from "styled-components";
import designSystemColors from "../../../../../styles";

export const AntModal = styled(Modal).attrs({
  className: "custom-modal-confirmation",
})`
  .ant-modal-content {
    border-radius: 16px;
    overflow: hidden;
  }

  .ant-modal-header {
    border-radius: 16px 16px 0 0;
    border-bottom: none;
  }

  .ant-modal-body {
    padding: 24px;
  }
`;

export const ModalTitle = styled.span`
  font-family: "Roboto", sans-serif;
  font-weight: bold;
  font-size: 18px;
`;

export const Description = styled.p`
  font-size: 14px;
  font-weight: medium;
  color: ${designSystemColors.grayChart};
  margin-bottom: 20px;
`;

export const SalesListContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${designSystemColors.backgrounds.lightGray};
  border: 1px solid ${designSystemColors.border.lightGray};
  border-radius: 8px;
  padding: 16px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const Key = styled.span`
  font-family: "Roboto", sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: ${designSystemColors.textDark};
`;

export const Value = styled.span`
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${designSystemColors.textDark};
`;

export const TotalValue = styled.span`
  font-family: "Roboto", sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: ${designSystemColors.generalButtons};
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
`;
